var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "member-account-cell" },
    [
      _c("div", { staticClass: "member-account-cell__container" }, [
        _vm.vipLevel !== null && _vm.showVipTag
          ? _c(
              "div",
              { staticClass: "member-account-cell__left" },
              [
                _c(
                  "el-tag",
                  {
                    staticClass: "member-account-cell__vip",
                    attrs: { size: "mini", type: _vm.tagType },
                  },
                  [_vm._v(" " + _vm._s(_vm.vipText) + " ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "member-account-cell__right" },
          [
            _vm.clickable
              ? _c(
                  "el-button",
                  {
                    staticClass: "member-account-cell__name-btn",
                    attrs: { type: "text", size: "mini" },
                    on: { click: _vm.handleClick },
                  },
                  [_vm._v(" " + _vm._s(_vm.displayUsername) + " ")]
                )
              : _c("span", { staticClass: "member-account-cell__name-text" }, [
                  _vm._v(_vm._s(_vm.displayUsername)),
                ]),
            _c("div", { staticClass: "member-account-cell__uid" }, [
              _vm._v(_vm._s(_vm.uidText)),
            ]),
          ],
          1
        ),
      ]),
      _vm.enableDetailDialog && _vm.detailDialogVisible && _vm.clickable
        ? _c("MemberDetailDialogV2", {
            attrs: {
              visible: _vm.detailDialogVisible,
              "member-uid": _vm.detailMemberUid,
              "user-info": _vm.detailUserInfo,
              "default-detail-tab-type": _vm.defaultDetailTabType,
            },
            on: {
              "update:visible": function ($event) {
                _vm.detailDialogVisible = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }